// import './extends'

export * from './interface'

export { RetryOptions } from './task-man'
export { RegistryItem, RegistryItemData, RegItemUrlData } from './registry'
export { LoaderConfigOptions } from './config'
export { IBSheetOptions } from './ibsheet'
export { IBSheetLoaderStatic } from './main'

/**
 * test prototype
 * @hidden
 */
// const fn = IBSheetLoaderStatic.prototype
// fn.double = double
// fn.power = power
